// extracted by mini-css-extract-plugin
export default {"heroHeader":"heroHeader_c2r_6","heroHeaderContainer":"heroHeaderContainer_CBpjb","asosWorldLogoContainer":"asosWorldLogoContainer_aiIXS","asosWorldLogo":"asosWorldLogo_d4tzP"};